import { canv } from "@/canv/global.js";
import { Shape } from "../shape";

export class ShapeAssembly extends Shape {
    width = 200;
    height = 164;

    needFill = false;

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();

        const rw = w * 0.25;
        const rh = h * 0.3;

        const rw2 = w * 0.36;
        const rh2 = h * 0.41;

        canv.ctx.moveTo(x, y + h / 2);
        canv.ctx.lineTo(x + w * 0.18, y + h / 2);

        canv.ctx.moveTo(x + w * 0.43 + rw, y + h / 2);
        canv.ctx.ellipse(x + w * 0.43, y + h / 2, rw, rh, 0, 0, Math.PI * 2);

        canv.ctx.moveTo(x + w * 0.43, y + (h - 2 * rh2) / 2);
        canv.ctx.ellipse(x + w * 0.43, y + h / 2, rw2, rh2, 0, Math.PI * 1.5, Math.PI * 0.5);

        canv.ctx.moveTo(x + w * 0.43 + rw2, y + h / 2);
        canv.ctx.lineTo(x + w, y + h / 2);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${stroke}" d="M10.41 3a8.84 8.84 0 0 1 8.7 8.26H23v1.48h-3.9A8.84 8.84 0 0 1 10.41 21v-1.48A7.4 7.4 0 0 0 17.69 12a7.4 7.4 0 0 0-7.28-7.53V3Z"/>
                <path fill="${stroke}" fill-rule="evenodd" d="M10.37 5.9a6 6 0 0 1 5.91 6.1 6 6 0 0 1-5.91 6.1 5.98 5.98 0 0 1-5.87-5.36H1v-1.48h3.5a5.98 5.98 0 0 1 5.87-5.36Zm0 1.48A4.55 4.55 0 0 0 5.9 12c0 2.56 2 4.62 4.47 4.62A4.55 4.55 0 0 0 14.83 12c0-2.56-2-4.62-4.46-4.62Z" clip-rule="evenodd"/>
            </svg>
        `;
    }
}
